const Single = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Previsions/Single')
const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Previsions/Search')

export default [
  {
    path: 'previsions/create',
    name: 'PrevisionsCreate',
    component: Single,
    meta: {
      title: 'Adicionar Previsão',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'previsions',
        action: 'create'
      }
    }
  },
  {
    path: 'previsions/:id',
    name: 'PrevisionsEdit',
    component: Single,
    meta: {
      title: 'Editar Previsão',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'previsions',
        action: 'read'
      }
    }
  },
  {
    path: 'previsions',
    name: 'PrevisionsSearch',
    component: Search,
    meta: {
      title: 'Previsões',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'previsions',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/previsions.js